import { useWindowScroll } from "@vueuse/core";
import { computed } from "vue";
import { headerScrolledCoreHeight, headerStaticHeight } from "./height";

export default function useHeaderScrolled() {
  const { y } = useWindowScroll();
  return computed(() => {
    if (headerStaticHeight.value === undefined || headerScrolledCoreHeight.value === undefined) return false;
    return y.value > headerStaticHeight.value - headerScrolledCoreHeight.value;
  });
}
